import React from 'react';
import './NotFound.scss';

const NotFound = () => {
  return (
    <div>
      <h1>404 - Page Not Found</h1>
      <p>Oops, the page you are looking for does not exist.</p>
    </div>
  );
};

export default NotFound;
